var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-container',{attrs:{"custom":1600,"min-height":0}},[_c('app-page-header',{attrs:{"design":"new","title":"Client refunds","compact":""}}),_c('AppTabs',{attrs:{"design":"new","refined":"","weight":"medium","tabs":_vm.tabs}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }